import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJCESearch from './DJCESearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJCESearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJCEPage, [state.DJCEPage]);

    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJCESearchCuantity = async () => {
            try {
                setLoader(true);

                const DJCESearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 5,
                    });

                if (DJCESearchCuantity) {
                    apiTablePages = DJCESearchCuantity.data;

                    getDJCESearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJCESearchCuantity();
    }, [tablePage, SearchParameters.declaraciones]);

    async function getDJCESearch() {
        try {
            setLoader(true);

            const DJCESearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 5,
                pagina: tablePage,
            });

            if (DJCESearch) {
                setTableData(buildTableData(DJCESearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJCEs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de Cosecha Efectiva',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJCEPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-E-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaEfectiva + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJCESearch tableData={tableData} />;
}

export default DJCESearchContainer;
